import React, { forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react'
import './index.less'
import { Form, Space, Tooltip, Typography } from 'antd'
import { SettingOutlined } from '@ant-design/icons'
import Flex from '../Flex'
import Item, { defaultTemplate } from './Item'
import defaultlogo from '../../assets/images/template-default.png'
import { queryTemplateEnv } from '@/api/modules/community'
import ItemManage from './ItemManage'
import config from '@/config'

type ExperEnvCenterProps = {
    labCode: string              // 实验室code
    initTemplate?: string        // 初始化选中的环境模板
    ref?: any
}

let ExperEnvCenter: React.FC<ExperEnvCenterProps> = (props, ref) => {

    const { labCode, initTemplate } = props

    const form = Form.useFormInstance()

    const [selectIndex, setSelectIndex] = useState(0)

    const handel = useRef<any>()


    const items = [
        {
            label: '全部',
            children: <Item ref={handel} key='all' type='ALL' fetchTemplateEnv={async () => fetchTemplateEnv('ALL')} />,
        },
        {
            label: '当前实验室',
            children: <Item ref={handel} key={'current'} type='CURRENT' fetchTemplateEnv={async () => fetchTemplateEnv('CURRENT')} />,
        },
        {
            label: '我管理的实验室',
            children: <ItemManage ref={handel} key={'manager'} type='MANAGER' fetchTemplateEnv={async () => fetchTemplateEnv('MANAGER')} />,
        },
        {
            label: '环境广场',
            children: <Item ref={handel} key={'square'} type='SQUARE' fetchTemplateEnv={async () => fetchTemplateEnv('SQUARE')} />,
        },
    ]

    useImperativeHandle(ref, () => ({
        reFresh: handel.current?.reFresh
    }))
    

    // // 空白模板
    // const defaultTemplate = {
    //     id: 'default-template-id',
    //     name: '空白模板',
    //     logo: defaultlogo,
    //     description: '这是一个空白模板'
    // }

    // 查询环境模板
    // 全部
    // 当前实验室
    // 管理的实验室
    // 广场
    const fetchTemplateEnv = async (type: 'ALL' | 'CURRENT' | 'MANAGER' | 'SQUARE') => {
        return await queryTemplateEnv({ labCode, type })
    }

    useEffect(() => {
      if (initTemplate) {
        form.setFieldValue('template', initTemplate)
      } else {
        form.setFieldValue('template', {...defaultTemplate})
      }
    }, [initTemplate])
    


    return (
        <div className='ExperEnvCenter'>
            <Flex justify='space-between'>
                <Space size={30}>
                    {
                        items.map((item, index: number) => {
                            return <span onClick={() => { setSelectIndex(index) }} className='ExperEnvCenter-navitem' key={index} data-select={index === selectIndex}>{item.label}</span>
                        })
                    }
                </Space>
                <Tooltip
                    placement="bottomLeft"
                    title={'自定义创建环境后，请在当前页刷新后才可获取最新环境数据'}
                    arrow={false}
                    color='white'
                    // trigger={'click'}
                    overlayClassName='custom-tooltip'
                >
                    <Typography.Link onClick={() => {
                        window.open(`${config.osURL}admin/base/labenv?labCode=${labCode}`)
                    }}><Space size={4}><SettingOutlined />自定义</Space></Typography.Link>
                </Tooltip>
            </Flex>
            <Form.Item noStyle name='template'>
                <div className='ExperEnvCenter-container'>
                    {items[selectIndex].children}
                </div>
            </Form.Item>
        </div>
    )
}

ExperEnvCenter = forwardRef(ExperEnvCenter as any)

export default ExperEnvCenter